import { useTranslation } from "react-i18next";
import { ProductToolbar } from "./ProductToolbar";
import { ProductList } from "./ProductList";

const Products = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="mb-6 p-6 rounded-xl bg-white shadow-sm">
        <h1 className="text-2xl font-bold mb-4">{t("products.title")}</h1>
        <ProductToolbar />
      </div>

      <ProductList />
    </>
  );
};

export default Products;
